import { render, staticRenderFns } from "./test-timeline.vue?vue&type=template&id=70985894&scoped=true&"
import script from "./test-timeline.vue?vue&type=script&lang=js&"
export * from "./test-timeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70985894",
  null
  
)

export default component.exports